import { useParticipants } from "@livekit/components-react";
import {
	HoverCard,
	HoverCardContent,
	HoverCardTrigger,
} from "@/components/ui/hover-card";
import { ScrollArea } from "@/components/ui/scroll-area";
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@/components/ui/tooltip";
import { getParticipantDisplayName } from "@/lib/livekit-utils";

export function ParticipantList() {
	const participants = useParticipants();

	const participantCount = participants.length;

	return (
		<HoverCard>
			<HoverCardTrigger asChild>
				<span className="cursor-pointer text-muted-foreground text-sm hover:text-foreground">
					{participantCount} viewer{participantCount !== 1 ? "s" : ""}
				</span>
			</HoverCardTrigger>
			<HoverCardContent align="end" className="w-56">
				<div className="space-y-2">
					<h4 className="font-medium text-sm">Participants</h4>
					<ScrollArea className="max-h-48">
						<div className="space-y-1">
							{participants.map((participant) => (
								<Tooltip key={participant.sid}>
									<TooltipTrigger asChild>
										<div className="flex items-center gap-2 rounded-md px-2 py-1 text-sm">
											<div className="size-2 shrink-0 rounded-full bg-green-500" />
											<span className="truncate">
												{getParticipantDisplayName(participant)}
											</span>
											{participant.isLocal && (
												<span className="shrink-0 text-muted-foreground text-xs">
													(you)
												</span>
											)}
										</div>
									</TooltipTrigger>
									<TooltipContent side="left">
										{getParticipantDisplayName(participant)}
									</TooltipContent>
								</Tooltip>
							))}
						</div>
					</ScrollArea>
				</div>
			</HoverCardContent>
		</HoverCard>
	);
}
